import React, { useEffect, useState } from 'react'
import { Button, FormCheck, Modal, CloseButton } from 'react-bootstrap'
import classNames from 'classnames'
import getConfig from 'next/config'
import { format, isAfter } from 'date-fns'

import styles from './LegalModal.module.scss'

const { publicRuntimeConfig } = getConfig()

const LegalModal = ({
  agreements,
  show,
  setShow,
  form,
  callback,
  bypassAccept = false,
  global = false
}) => {
  //const [modalTitle, setModalTitle] = useState('')
  const [latestDate, setLatestDate] = useState(new Date())
  const [title, setTitle] = useState([])
  const [body, setBody] = useState([])
  const [agreeChecked, setAgreeChecked] = useState([])
  const [isLoading, setIsLoading] = useState(true)

  const handleAccept = async () => {
    const apiUrl = `${publicRuntimeConfig.legalApiBaseUrl}/api/v1/legalAcceptance`
    const response = await fetch(apiUrl, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        legalTypes: agreements
      })
    })

    const responseData = await response.json()

    if (responseData.statusCode === 200) {
      setAgreeChecked(false)
      setShow(false)
      if (callback) callback()
    }
  }

  const handleBypass = () => {
    setAgreeChecked(false)
    setShow(false)
    callback()
  }

  const handleChange = (event) => {
    const checkboxId = event.target.id
    // REMOVE ID IF USER UNCHECKS THE CHECKBOX
    if (agreeChecked.includes(checkboxId))
      setAgreeChecked((currChecked) => currChecked.filter((id) => id !== checkboxId))
    // ADD ID IF USER CHECK THE CHECKBOX
    else setAgreeChecked((currChecked) => [...currChecked, checkboxId])
  }

  const handleClose = () => {
    setAgreeChecked(false)
    setShow(false)
  }

  useEffect(() => {
    const getData = async () => {
      const query = new URLSearchParams()
      agreements.forEach((agreement) => query.append('legalTypes', agreement))
      const apiUrl = `${publicRuntimeConfig.legalApiBaseUrl}/api/v1/legalDocs?${query.toString()}`

      const response = await fetch(apiUrl)
      const agreementsData = await response.json()

      let tempTitle = []
      let tempBody = []

      let tempLatestDate = ''

      if (agreementsData.data) {
        agreementsData.data.map((item) => {
          if (item !== null) {
            let newDate = new Date(item.updated_at)

            if (!tempLatestDate) {
              tempLatestDate = newDate
            } else {
              tempLatestDate = isAfter(newDate, tempLatestDate) ? newDate : tempLatestDate
            }

            tempTitle.push(item.title)
            tempBody.push(item.body)
          }
        })
      }

      /*if (tempTitle) {
        if (tempTitle.length > 1) {
          setModalTitle('Knox ')
        } else {
          setModalTitle(tempTitle[0])
        }
      }*/

      setLatestDate(tempLatestDate)
      setTitle(tempTitle)
      setBody(tempBody)

      setIsLoading(false)
    }

    getData()
  }, [])

  if (isLoading) return null
  return (
    <Modal
      show={show}
      onHide={handleClose}
      className={classNames('modal-kp5', styles.legalModal)}
      animation={false}
      size="xl"
      fullscreen={true}
    >
      <Modal.Header closeButton className="px-0 mx-3">
        <div>
          <Modal.Title>Accept our Legal Terms</Modal.Title>
          {global && (
            <div className={'mt-4'}>
              <p>
                <strong>
                  Samsung Knox Legal terms have changed on {format(latestDate, 'yyyy/MM/dd')}.
                </strong>
              </p>
              <p>
                Please read and agree to these terms and conditions to continue enjoying this
                service.
              </p>
              <p className="mb-0">The following legal documents have changed:</p>
              {title &&
                title.map((item, key) => (
                  <ul className="mb-0" key={key}>
                    <li>{title[key]}</li>
                  </ul>
                ))}
            </div>
          )}
          <CloseButton id="ga-kp-AcceptOurLegalTerms-close" onClick={handleClose} />
        </div>
      </Modal.Header>
      <Modal.Body>
        <div className={styles.legalBody}>
          {body &&
            body.map((item, key) => (
              <div key={key} id={`${key}-legal`}>
                <h5 className="font-weight-bold">{title[key]}</h5>
                <div dangerouslySetInnerHTML={{ __html: item }} />
                <hr />
              </div>
            ))}
        </div>
      </Modal.Body>
      <Modal.Footer className={classNames(styles.legalFooter, 'px-0 mx-3', 'd-block')}>
        <div className="mb-3">
          {title &&
            title.map((item, key) => {
              const term = `I have read and agree to the ${item}`
              const id = term
                .split(' ')
                .map((string) => string.charAt(0).toUpperCase() + string.slice(1))
                .join('')
              return (
                <div key={key}>
                  <FormCheck custom className={classNames('sm')}>
                    <FormCheck.Input
                      onChange={handleChange}
                      id={`ga-kp-AcceptOurLegalTerms-${id}`}
                    />
                    <FormCheck.Label htmlFor={`ga-kp-AcceptOurLegalTerms-${id}`}>
                      {term}.
                    </FormCheck.Label>
                  </FormCheck>
                </div>
              )
            })}
        </div>
        <div className="d-flex justify-content-end">
          <Button
            id="ga-kp-AcceptOurLegalTerms-cancel"
            variant="outline-primary"
            size={'sm'}
            onClick={handleClose}
          >
            Cancel
          </Button>
          <Button
            id="ga-kp-AcceptOurLegalTerms-accept"
            type={form ? 'submit' : 'button'}
            form={form}
            variant="primary"
            size={'sm'}
            onClick={bypassAccept ? handleBypass : handleAccept}
            className="ml-2"
            disabled={agreeChecked.length === 0 || agreeChecked.length !== title.length} // ACCEPT BUTTON TO BE ENABLED IF ALL CHECKBOX IS SELECTED
          >
            Accept
          </Button>
        </div>
      </Modal.Footer>
    </Modal>
  )
}

export default LegalModal
